<script setup>
import VLazyImage from 'v-lazy-image';

defineProps({
  img: {
    required: true,
    type: Object,
  },
});

const createImgPath = (fileName) => `${process.env.VUE_APP_ASSET_PATH}${fileName}`;
</script>
<template>
  <div class="bg-ford-gray-light drop-shadow-[0_4px_8px_#00000029] overflow-hidden">
    <div class="h-[13.3125rem] desktop:h-[23.125rem]">
      <v-lazy-image
        :src="createImgPath(img.fileName)"
        :alt="img.alt"
        class="object-cover overflow-hidden w-full h-full"
      />
    </div>
    <div class="p-8">
      <div class="flex mb-5">
        <slot name="icons"></slot>
      </div>
      <div
        class="
          font-FordAntennaSemiBold
          text-lg text-ford-blue-dark
          mb-4
          desktop:text-2xl
        "
      >
        <slot name="title"></slot>
      </div>
      <div class="mb-8">
        <div
          class="
            font-FordAntennaMed
            text-xs text-ford-gray-darker
            leading-relaxed
            desktop:text-base
          "
        >
          <slot name="info"></slot>
        </div>
        <div
          class="
            hidden
            desktop:block
            font-FordAntennaReg
            text-base text-ford-blue-dark
            mt-5
          "
        >
          <slot name="description"></slot>
        </div>
      </div>
      <div class="desktop:flex desktop:justify-between">
        <div>
          <slot name="button"></slot>
        </div>
        <div class="mt-4 desktop:mt-0 desktop:self-end">
          <slot name="disclosure"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
